import { render, staticRenderFns } from "./CheckoutLoginForm.vue?vue&type=template&id=640f6b01"
import script from "./CheckoutLoginForm.vue?vue&type=script&lang=js"
export * from "./CheckoutLoginForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports